////
/// ============================================================================
/// COMPONENT / Map
/// ============================================================================
///
/// @group components
////

import {Loader} from "@googlemaps/js-api-loader"

export default () => {
    const content = document.querySelector(".js-map");

    if (!content) {
        return;
    }

    const loader = new Loader({
        apiKey: content.dataset.key,
        version: "weekly",
    });

    loader.load().then(() => {
        const map = new google.maps.Map(content, {
            backgroundColor: 'hsl(0, 13%, 14%)',
            center: {
                lat: parseFloat(content.dataset.lat),
                lng: parseFloat(content.dataset.lng)
            },
            zoom: parseInt(content.dataset.zoom),
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}],
        });

        const marker = new google.maps.Marker({
            position: map.getCenter(),
            animation: google.maps.Animation.DROP,
            icon: {
                path: "M16,0C10.1,0,4,4.5,4,12c0,7.1,10.8,18.2,11.3,18.7c0.2,0.2,0.4,0.3,0.7,0.3s0.5-0.1,0.7-0.3 C17.2,30.2,28,19.2,28,12C28,4.5,21.9,0,16,0z M16,16c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S18.2,16,16,16z",
                fillColor: "white",
                fillOpacity: 0.8,
                strokeWeight: 0,
                rotation: 0,
                scale: 1.5,
                anchor: new google.maps.Point(16, 32), // Size / 2
            },
            map: map
        });
    });
};
